module.exports = __webpack_public_path__ + "static/media/c2dh.8c1e5472.jpg";